var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelfCatering = function SvgSelfCatering(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m14.772 2.385 12.776 9.522.144 15.415-25.014.37-.37-15.493c0-.294 2.291-1.958 2.504-2.123z"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.67 19.578h1.603a.32.32 0 0 0 .32-.321c-.043-5.002-1.056-9.298-1.923-9.298v14.748M10.407 9.959v3.206a1.924 1.924 0 0 0 3.847 0V9.96m-1.924-.001v14.748"
  }))));
};
export default SvgSelfCatering;